<template>
  <div class="createdMail">
    <!-- <div class="back" @click="back">
      <i class="el-icon-arrow-left"></i> 保存并返回
    </div> -->
    <!-- 步骤条 -->
    <div class="step">
      <el-steps :active="activatedShow" align-center >
        <el-step title="邮件内容设置"></el-step>
        <el-step title="推送设置"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <!-- 邮件内容设置 -->
    <div v-show="activatedShow==1">
      <contentSet  @contentSetFormData="contentSetFormData" ref="contentSet" @AIdrawer="AIdrawer"/>
    </div>
    <!-- 推送设置 -->
    <div v-show="activatedShow==2" >
      <pushingSet  @pushingSetFormData="pushingSetFormData" ref="pushingSet" />
    </div>
    <!-- 完成 -->
    <div v-if="activatedShow==3">
      <!-- :submitTotal="formData.submitTotal"  -->
      <finishSet :formData="formData" :attachmentVos="attachmentVos" :signature="tryForm.signature" :filterGroupArr="filterGroupArr" :tempUrlShow="tempUrlShow"/>
    </div>
    <el-row >
      <el-col :span="spanLen">
        <div  :class="'footBtn'+spanLen">
          <div class="submitExplain" v-if="activatedShow==3" >
            提交后将根据实际发送成功的邮件进行资源包点数扣减
          </div>
        <!-- 取消 -->
          <el-button @click="cancel" size="small">取消</el-button>
          <!-- 上一步 -->
          <el-button @click="prev" size="small" v-if="activatedShow!=1" v-no-more-click>上一步</el-button>
          <!-- 保存草稿 -->
          <el-button @click="saveDraft" size="small" v-no-more-click >保存草稿</el-button>
          <!-- 预览并测试 -->
          <el-button @click="preview"  size="small" v-if="activatedShow==1" v-no-more-click>预览并测试</el-button>
          <!-- 下一步 -->
          <el-button  @click="next" size="small"  type="primary" v-if="activatedShow!=3" v-no-more-click>下一步</el-button>
          <!-- 提交 -->
          <!-- <div v-if="activatedShow==3" class="footBtnsubmit"> -->
          <el-button v-if="activatedShow==3"  @click="submit" size="small" type="primary"  class="footBtnsubmit" :loading="submitDisable" >确认提交</el-button>
          <!-- </div> -->
        </div>
      </el-col>

    </el-row> 
    <!-- 预览并测试 -->
    <div class="dialogMailDiv" v-if="dialogMail">
      <el-dialog
        title="邮件预览"
        :visible.sync="dialogMail"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :lock-scroll="true"
        :append-to-body="true"
        custom-class="dialogMail"
        >
        <div class="editMailBodyDiv">
          <span>主题：</span>
          <span>{{formData.title}}</span>
          <div v-if="formData.showUserName==1" class="showUserName">
           {{formData.language==1?'Dear ${UserName}':'亲爱的${UserName}'}} 
          </div>
          <div class="">
            <div class="editMailBody" v-html="formData.content"></div>
          </div>
          <div v-if="attachmentVos.length>0">
            <div class="downLoadBtn" v-for="item in attachmentVos" :key="item.hashCode">
              <el-button type="primary"   @click="downLoad(item)">{{item.fileName}}</el-button>
            </div>
          </div>

          <div class="SingContent">
            <div v-if="formData.signatureId==''">
              <!-- 不显示签名 -->
            </div>
            <div v-else >
              <div v-html="tryForm.signature"></div>
            </div>
          </div>
          <div class="unsubscribe">
            退订链接：为保证邮件触达率，已为您使用默认退订链接
          </div>
           <!-- <button class="downLoadBtn">{{attachmentVos[0].fileName}}</button> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-form :model="tryForm" :rules="tryFormRules">
            <el-form-item prop="replyEmail">
              <el-input placeholder="可发送预览邮箱查看并检查邮件格式内容" v-model.trim="tryForm.replyEmail">
                <template slot="append">
                  <el-button  @click="sendTryEmail" size="small"  v-no-more-click>发送一封测试邮件</el-button>
                </template>
              </el-input>
              <div class="footertips" v-if="!isSendTryEmail">
                测试邮件发送数量已达上限，如需帮助请联系客服
              </div> 
            </el-form-item>
          </el-form>
        </span>
      </el-dialog>
    </div>

    <!-- 购买图片弹框点数不足 -->
    <!-- <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog"/> -->
  </div>
</template>
<script>
import contentSet from "@/components/intellect-marketing/mailDetail/contentSet"
import pushingSet from "@/components/intellect-marketing/mailDetail/pushingSet"
import finishSet from "@/components/intellect-marketing/mailDetail/finishSet"
import previewMail from "@/components/intellect-marketing/mailDetail/previewMail"
import {edmSubjectUpsert,findById,previewSend} from "@/utils/api/edmSubject"
import { downloadFileFun } from '@/utils/common.js'
import { fileUrl } from '@/utils/config.js'
import { getDictByType, } from '@/utils/api/common.js';
import vipBoxDialog from "@/components/common/VIPdialog"
export default {
  components:{
    contentSet,pushingSet,finishSet,previewMail,
    // vipBoxDialog
  },
  data(){
      // 邮箱校验
    var checkEmail = (rule, value, callback) => {
        const reg =
          /^([a-zA-Z0-9_\-.]+)@(([a-zA-Z0-9-]+\.)+)([a-zA-Z]{2,10}|[0-9]{1,3})$/;
        if (value === "" || !value) {
          return callback(new Error('输入邮箱'));
        }
        else if (!reg.test(value)) {
          return callback(new Error('邮箱格式有误'));
        } else {
          callback();
        }
    };
    return{
      activatedShow:1,
      formData:{
        hashcodeList:[],//附件hashcode
        submitTotal:'',//提交总用户
        id:'',//营销邮件ID,仅编辑时有值
        name:'',//任务名称
        sendType:1,//发送数据类型 1=条件过滤推送; 2=全部联系人用户
        state:'',//邮件状态 4=提交 5=保存草稿
        title:'',//邮件标题
        replyEmail:this.$store.state.supplierState.replyMail,//回复邮箱  
        showUserName:1,//邮件称谓 0=不显示 1=亲爱的xx
        sendModel:1,//发送模式 1=立即发送;2=定时发送
        scheduleSendTime:'',//定时发送的时间
        content:'',//邮件正文
        filterConditionsMap:{//过滤条件按条件搜索，后端需要查询数据用
          areas:[],//地区
          industry:[],//行业
          title:[],//职位
          level:[],//客户等级
          followStatus:[],//跟进状态
          unSendDateTime:[],//邮箱发送记录
          addUserTime:[],//客户添加时间
        },
        customerUserSearch:{//按条件查询-条件
          curPage:1,
          pageSize:10,
          areas:[],//地区
          industry:[],//行业
          title:[],//职位
          level:[],//客户等级
          followStatus:[],//跟进状态
          unSendDateTime:[],//邮箱发送记录
          addUserTime:[],//客户添加时间
        },
        signatureId:'',//邮件签名
        language:1,//语言 1=英文 2=中文
        scheduleSendTimezone:'Asia/Shanghai',//时区
        scheduleSendTimezoneTime:"",//定时的时间
      },
      contentFormFlag:false,//内容设置校验
      pushingFormFlag:false,//推送设置校验
      dialogMail:false,//预览邮件
      tryForm:{//测试邮箱
        replyEmail:'',
        showUserName:'',
        signature:'',
      },
      tryFormRules:{
        replyEmail:[
          { required: false, validator: checkEmail, trigger: "blur" },
        ],
      },
      tryEmailNum:0,//测试邮箱次数，只能发五次，如果页面刷新将重新计数
      isSendTryEmail:true ,//是否可以发送测试邮箱
      // submitTotal:0,//目标用户数
      filterGroupArr:[],//按条件搜索的条件
      attachmentVos:[],
      tempUrlShow:false,
      submitDisable:false,
      // vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
      spanLen:24,
      submitFlag:false,

    }
  },
 async created () {
   await  this.getInitDictByTypeData()
    if (this.$route.query.id != undefined) {
      this.formData.id = this.$route.query.id;
      this.draftData();
    }else{
      // console.log(this.formData.replyEmail)
      this.tryForm.replyEmail=this.formData.replyEmail
    }
    window.localStorage.setItem('formData', JSON.stringify(this.formData) )
  },
  methods:{
    // // 根据类型批量获取字典数据
    async getInitDictByTypeData(){
      let prams=[{"key":"edm_un_send_date"},//发送条件
      {"key":'saas_supplier_customer_follow_status'},//跟进状态
      {"key":'saas_supplier_customer_level'},//客户等级
      {"key":'edm_purpose'},//营销目的
      ]
      const res = await getDictByType(prams)
       if(res.rspResult.bizCode==200){
        const codeMap=res.data.codeMap
        this.$refs.contentSet.getInitDictByType(codeMap)
        this.$refs.pushingSet.getInitDictByType(codeMap)
      }else{
        this.$message.error(res.rspResult.message);
      }
    },
    // 编辑
    async draftData(){
      const params={
        id:this.formData.id
      }
      const res =await findById(params)
      // this.formData=res.data
      Object.keys(this.formData).map(item=>{
        if(res.data[item]!=undefined){
          this.formData[item]=res.data[item]
        }
      })
      this.attachmentVos=[]
      let hashcodeList=[]
      if(res.data.attachmentVoss!=[]&&res.data.attachmentVos!=null){
        // this.attachmentVos.push(res.data.attachmentVos)
        // this.formData.hashcode=this.attachmentVos[0].hashCode
        this.attachmentVos=res.data.attachmentVos
        res.data.attachmentVos.map(item=>{
          hashcodeList.push(item.hashCode)
        })
        this.formData.hashcodeList=hashcodeList
      }else{
        this.formData.hashcodeList=[]
      }
      this.tryForm.replyEmail=this.formData.replyEmail
      this.$refs.contentSet.contentSetData(res.data)
      this.$refs.pushingSet.pushingSetData(res.data)
      window.localStorage.setItem('formData',JSON.stringify(this.formData))
    },
    // 取消
    cancel(){
      this.$confirm(
        `现在取消会放弃当前编辑的内容，确认取消吗?`,
        `提示`,
        {
          confirmButtonText: `确定`,
          cancelButtonText: `取消`,
          type: "warning",
        }
      ).then((_) => {
          this.submitFlag=true
          this.$router.back()
        }).catch((_) => { });
    },
    // 上一步
    prev(){
      if(this.activatedShow==3){
        this.$refs.pushingSet.paramsCopy()
      }
      this.activatedShow=this.activatedShow-1
      const listEle= document.querySelector('.el-scrollbar-wrap');
      listEle.scrollTop = 0;
    },
    // 保存草稿
    async saveDraft(){
      this.submitFlag=true
      // 第一步保存
      this.formData.state=5
      this.formData.name=this.formData.name.trim()
      this.formData.title=this.formData.title.trim()
      if(this.activatedShow==1){
        await this.contentForm()
        if(this.contentFormFlag){
         const res= await edmSubjectUpsert(this.formData)
         if(res.rspResult.bizCode==200){
            this.$message.success(res.rspResult.message);
            this.$router.back()
         }
        }
      }
      // 第二步保存
      if(this.activatedShow==2){
        await this.pushingForm()
        if(this.pushingFormFlag){
        const res=  await edmSubjectUpsert(this.formData)
          if(res.rspResult.bizCode==200){
            this.$message.success(res.rspResult.message);
            this.$router.back()
          }
        }
      }
      // 第三步保存
      if(this.activatedShow==3){
        const res=  await edmSubjectUpsert(this.formData)
        if(res.rspResult.bizCode==200){
          this.$message.success(res.rspResult.message);
          this.$router.back()
        }
      }
    },
    // 预览并测试
    async preview(){
      console.log('预览并测试,preview')
       await this.contentForm()
        if(this.contentFormFlag){
          this.dialogMail=true
        }
    },
    // 预览邮箱
    handleClose(){
      this.dialogMail=false
    },
    // 发送测试邮箱
    async sendTryEmail(){
      let urltemp=`/res/attach/download-temp?code=`
      let urlstatic=`/download-static?code=`
      if(this.tryEmailNum>=5){
        this.isSendTryEmail=false
      }
      let attachList=[]
      this.attachmentVos.map(item=>{
        let temp={
          fileName:item.fileName,
          fileUrl:''
        }
        if(item.response==undefined){
          temp.fileUrl=`${fileUrl}${urlstatic}${item.hashCode}`
        }else{
          temp.fileUrl=`${fileUrl}${urltemp}${item.hashCode}`
        }
        attachList.push(temp)
      })
      if(this.isSendTryEmail){
        // let tos=[]
        // tos.push(this.tryForm.replyEmail)
        this.tryForm.signature=this.formData.signatureId==-1?'':this.tryForm.signature
        const params={
          tos: this.tryForm.replyEmail, //测试收件邮箱
          replyEmail: this.formData.replyEmail, //回复邮箱
          title: this.formData.title, //标题
          content: this.formData.content, //发送内容
          signature: this.tryForm.signature, //签名内容
          userStateId: "92", //区域
          userName: this.formData.showUserName != 0 ? "${UserName}" : "",//名称
          showUserName: this.formData.showUserName,//显示名称
          id:this.formData.id,
          language:this.formData.language,//语言 1=英文 2=中文
          // fileName:this.attachmentVos.length>0?this.attachmentVos[0].fileName:'',
          // fileUrl:this.formData.hashcode?`${fileUrl}${url}${this.formData.hashcode}`:'',
          attachList:attachList
        }
        const res=await previewSend(params)
        if(res.rspResult.bizCode==200){
          this.tryEmailNum=this.tryEmailNum+1
          this.$message.success('发送成功')
        }
      }
    },
    // 下载  https://dev-file.haizol.com/preview-static?code=d278fdfa-c9e5-4850-8e7e-a466d655c1ab
    downLoad(item) {
      let url=`/res/attach/download-temp?code=`
      if(item.response==undefined){
        url=`/download-static?code=`
      }else{
        url=`/res/attach/download-temp?code=`
      }
      return downloadFileFun(`${fileUrl}${url}${item.hashCode}`)
    },
    // 下一步
   async next(){
      // 第一步=>第二步
      if(this.activatedShow==1){
        await this.contentForm()
        if(this.contentFormFlag){
          setTimeout(() => {
            this.activatedShow=this.activatedShow+1
                  // console.log('下一步,next')
            const listEle= document.querySelector('.el-scrollbar-wrap');
            listEle.scrollTop = 0;
          }, 500);
        }
      }
      // 第二步=>第三步
      if(this.activatedShow==2){
        await this.pushingForm()
        if(this.pushingFormFlag){
          setTimeout(() => {
            this.activatedShow=this.activatedShow+1
                  // console.log('下一步,next')
            const listEle= document.querySelector('.el-scrollbar-wrap');
            listEle.scrollTop = 0;
          }, 500);
        }
      }

    },
    // 提交
    async submit(){
      console.log('提交,submit')
      this.submitFlag=true
      this.submitDisable=true
      this.formData.state=4
      this.formData.name=this.formData.name.trim()
      this.formData.title=this.formData.title.trim()
      edmSubjectUpsert(this.formData).then(res=>{
        if(res.rspResult.bizCode==200){
          this.$message.success(res.rspResult.message);
          this.$router.back()
        }else 
        // if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
        //   this.vipCode=res.rspResult.bizCode
        //   this.$refs.vipBoxDialog.centerDialogVisible=true
        // }else
        {
          this.$message.error(res.rspResult.message)
          this.submitDisable=false
        }

      })

    },
    // 递归判断
    deepSubmit(data){

    },
    // 保存返回
    back(){
      this.$router.back()
    },
    // 邮件内容设置表单验证
    contentForm(){
      this.$refs.contentSet.contentForm().then((valid)=>{
        this.contentFormFlag=valid
      })
    },
    // 推送设置表单验证
   async pushingForm(){
      // this.$refs.pushingSet.pushingForm().then((valid)=>{
      //   this.pushingFormFlag=valid
      // })
      if(this.formData.sendModel==1){
        this.$refs.pushingSet.pushingForm().then((valid)=>{
          this.pushingFormFlag=valid
        })
      }

      if(this.formData.sendModel==2){
        let a= false
        let b=false
        this.pushingFormFlag=false
        await this.$refs.pushingSet.pushingForm().then((valid)=>{
          a=valid
        })
        await this.$refs.pushingSet.timezoneForm().then((valid)=>{
          b=valid
        })
        if(a&b){
          this.pushingFormFlag=true
        }
        console.log(a,b)
        console.log( this.pushingFormFlag)
      }
    },
    // 参数处理
    // 邮件内容设置参数处理
    contentSetFormData(property,val){
      // console.log(val)
      if(property=='SingContent'){
        this.tryForm.signature=val
      }else if(property=='attachmentVos'){
        this.attachmentVos=val
      }else if(property=='tempUrlShow'){
        this.tempUrlShow=val
      }else{
        this.formData[property]=val
      }
      
    },
    // 推送设置参数处理
    pushingSetFormData(property,val){
      // console.log(property,val)
      // if(property=='submitTotal'){
      //   this.formData.submitTotal=val
      // }else
       if(property=='filterGroupArr'){
        this.filterGroupArr=val
      }else{
        this.formData[property]=val
      }
      console.log(this.formData)
    },
    // AI窗口打开底部按钮需要样式更改
    AIdrawer(val){
      if(val){
        this.spanLen=16
      }else{
        this.spanLen=24
      }
    }
  },
  beforeRouteLeave(to, form, next) {
    let falg= window.localStorage.getItem('formData')==JSON.stringify(this.formData)?true:false
    // console.log(this.submitFlag)
    // console.log(window.localStorage.getItem('formData'))
    // console.log(JSON.stringify(this.formData))
    // console.log(falg)
   if(!this.submitFlag&&!falg){ 
    setTimeout(() => {
      // 此处必须要加延迟执行，主要解决浏览器前进后退带来的闪现
      this.$confirm(
        `检测到未提交的内容，确认离开页面？`,
        `提示`,
        {
          confirmButtonText: `确定`,
          cancelButtonText: `取消`,
          type: "warning",
        }
      )
      .then(() => {
        next(true);
      })
      .catch(() => {
        next(false);
      });
    }, 0);
   }else{
    next(true);
   }
  }
}
</script>

<style lang="scss" scoped>
.createdMail{
// 步骤条
::v-deep .step{
    padding-top: 16px;
    padding: 16px 0;
    border-bottom: 2px solid #F5F7FA;
    .el-step__title.is-process{
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 12px;
      color: #4F5D78;


    }
    .el-step__title.is-wait{
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 12px;
      color: #4F5D78;
      
    }
    .el-step__title.is-finish{
      font-weight: 500;
      font-size: 12px;
      color: #318CED ;
      font-family: SourceHanSansCN-Medium;

    }
    .el-step__icon{
      font-family: Arial-BoldMT;
      font-weight: BoldMT;
      font-size: 12px;
      color: #4F5D78;
      border: 1px solid;
      border-color:#CFD5DF;
    }
    .el-step__head.is-finish{
      border-color: #318CED;
      .el-step__icon.is-text{
        background: #318CED;
        color: #FFFFFF;
        border-color: #318CED;
      }
      // .el-step__line{
      //   height: 1px;
      //   background-color: #318CED;
      // }
    }
    .el-step__head.is-process{

    }
    .el-step__line{
        height: 1px;
        background-color:#CFD5DF;
      }

  }

}

.back{
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #4F5D78;
  background: #F5F7FA;
  padding-bottom: 15px;
  padding-top: 5px;
  cursor: pointer;
}
.activeSet{
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #066EB7 !important;
}
.footBtn16{
  text-align: center;
  width: 700px;
  margin:40px 0 40px 40px;
  .footBtnsubmit{
    // position: relative;
    // top: -90px;
    // .el-button{
      width: 292px;
    // }

  }
  .submitExplain{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #16181A;
    margin-bottom: 10px;
  }
}

.footBtn24{
  text-align: right;
  margin:40px;
  .footBtnsubmit{
    // position: relative;
    // top: -90px;
    // .el-button{
      width: 292px;
    // }

  }

  .submitExplain{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #16181A;
    margin-bottom: 10px;
  }
}
::v-deep .dialogMail{
    background: #F5F7FA;
    .el-dialog__body{
      padding: 0px 20px;
      height: 440px;
      overflow: auto;
      background: #F5F7FA;
    }
    .el-dialog__footer{
      padding-bottom: 16px;
      .el-form-item--small.el-form-item{
        margin-bottom:0px;
      }
    }
    /**修改全局的滚动条*/
    /**滚动条的宽度*/
    ::-webkit-scrollbar {
      width: 6px;
      scrollbar-width: 6px;
    }
    // 滚动条的滑块
    ::-webkit-scrollbar-thumb {
      background-color: rgba(144,147,153,.3);
      border-radius: 3px;
      scrollbar-color: rgba(144,147,153,.3);
    }
    scrollbar-width: thin;//滚动条变细，为none时隐藏滚动条
  // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
  }

::v-deep .dialogMailDiv{
  .editMailBodyDiv{

    padding: 16px;
    .showUserName{
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
  .dialogMail{
    background: #F5F7FA;
    .el-dialog__body{
      padding: 0px 20px;
      height: 440px;
      overflow: auto;
      background: #F5F7FA;
    }
    .el-dialog__footer{
      padding-bottom: 16px;
      .el-form-item--small.el-form-item{
        margin-bottom:0px;
      }
    }
    /**修改全局的滚动条*/
    /**滚动条的宽度*/
    ::-webkit-scrollbar {
      width: 6px;
    }
    // 滚动条的滑块
    ::-webkit-scrollbar-thumb {
      background-color: rgba(144,147,153,.3);
      border-radius: 3px;
    }
  }
  .editMailBody{
    div,
    span,
    object,
    li,
    ul,
    img iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    pre,
    a,
    em,
    img,
    strong,
    sub,
    sup,
    b,
    i,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    menu,
    nav,
    output,
    ruby,
    section,
    abstractDesc,
    time,
    mark,
    audio,
    video,
    input,
    textarea,
    select,
    button,
    meter,
    progress {
      margin: revert;
    }
    a {
      color: rgb(0, 0, 238) !important;
    }
    img {
      // width: 100%;
    }
  }
  .footerExplain{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #4F5D78;
    text-align: left;
  }
  .footertips{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #EF2A2A;
    text-align: left;
  }
}
.SingContent{
  line-height: 18px;
  // border: 1px solid #eeeeee;
  padding: 10px;
  margin-top: 4px;
  // width: 622px;
  overflow-x: auto;
  margin-top: 12px;
}
.unsubscribe{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;
  line-height: 30px;
}
.downLoadBtn{
  margin-top: 20px;
}
</style>